import { Col, Container, Row } from "reactstrap";
import Chip from "src/components/Common/UI/Chips/Chip";
import ParametersHeader from "../ParametersHeaders";
import PhonecentersMaintenance from "./PhonecentersMaintenance/PhonecentersMaintenance";
import PhonecentersSysModels from "./PhonecentersSysModels/PhonecentersSysModels";


const PhoneCenters = () =>{
  
    const chipHeaders = ["Συντηρητές", "Μοντέλα"];
    const chipItems: React.ReactNode[] = [
      <PhonecentersMaintenance />,
      <PhonecentersSysModels />,
    ];
  
    return (
      <div className="page-content">
        <ParametersHeader />
  
        <Container fluid>
          <Row>
            <Col xs={12}>
              {<Chip
                tabNavHeaderItems={chipHeaders}
                tabContentItems={chipItems}
                hasStatusCircle={false}
              />}
            </Col>
          </Row>
        </Container>
  
  
      </div>
    );
}

export default PhoneCenters